export const getCustomColumnQueryKey = (params) => [
  "get_custom_column",
  params,
];
